// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "5bd580474fd42e7f1ee6" + ".js";
};